module.exports = __webpack_public_path__ + "img/protect-privacy.80e1130f.svg";